var viewerConfig = {
  embedMode: "LIGHT_BOX",
  showDownloadPDF: false, 
  showPrintPDF: false
};

document.addEventListener("adobe_dc_view_sdk.ready", function () {
  document.getElementById("open-pdf");
});

function previewFile() {
  var adobeDCView = new AdobeDC.View({
    clientId: "344e4669347146ab9b4e50d63011cf4d"
  });
  
  adobeDCView.previewFile({
    content: {
      location: {
        url: "https://cdn.shopify.com/s/files/1/0536/2624/1223/files/MB_BrandStandards_B2B.pdf",
      },
    },
    metaData: {
      fileName: "MB_BrandStandards_B2B.pdf"
    }
  }, viewerConfig);
};

$('#open-pdf').on('click', function() {
  previewFile();
});

$(function() {
  $('.btn-download-asset').on('click', function() {
    let self = $(this),
        href = self.data('href');
    window.open(href, '_blank').location.href = href
  });
});